import { createContext, useEffect, useState, type FunctionComponent, type PropsWithChildren } from 'react';
import { type ProductSwatch } from '../../types/product.types';

export const DEFAULT_SWATCH_GROUP_NUM = 1;

type SwatchContextState = {
	hoveredSwatch: any;
	selectedSwatch: any;
	setHoveredSwatch: (swatch: ProductSwatch | undefined) => void;
	setSelectedSwatch: (swatch: ProductSwatch) => void;
	swatchGroupDisplayed: number;
	setSwatchGroupDisplayed: (group: number) => void;
};

const initialState: SwatchContextState = {
	hoveredSwatch: undefined,
	selectedSwatch: {},
	setHoveredSwatch: () => {},
	setSelectedSwatch: () => {},
	swatchGroupDisplayed: DEFAULT_SWATCH_GROUP_NUM,
	setSwatchGroupDisplayed: () => {}
};

export const SwatchContext = createContext<SwatchContextState>(initialState);

type SwatchContextProviderProps = {
	swatch?: ProductSwatch;
};

export const SwatchContextProvider: FunctionComponent<PropsWithChildren<SwatchContextProviderProps>> = ({ children, swatch }) => {
	const [selectedSwatch, setSelectedSwatch] = useState<ProductSwatch | undefined>(swatch);
	const [hoveredSwatch, setHoveredSwatch] = useState<ProductSwatch | undefined>(undefined);
	const [swatchGroupDisplayed, setSwatchGroupDisplayed] = useState<number>(DEFAULT_SWATCH_GROUP_NUM);

	useEffect(() => {
		setSelectedSwatch(swatch);
	}, [swatch]);

	const value = {
		hoveredSwatch,
		selectedSwatch,
		setHoveredSwatch,
		setSelectedSwatch,
		swatchGroupDisplayed,
		setSwatchGroupDisplayed
	};

	return <SwatchContext.Provider value={value}>{children}</SwatchContext.Provider>;
};
